import { Component, OnInit } from '@angular/core';
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/services/api/login.service';
import { Usuario } from '../entidad/usuario';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Credentials, Login } from 'src/app/auth/modelos/login.interface';
import { Router } from '@angular/router';
import * as crypto from "crypto-js";
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

  formLogin!: FormGroup;


  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];


  lblRespuesta = true;

constructor(
  private loginService : LoginService,
  private authServide: AuthService,
  private router:Router,
  private tokenStorage: TokenStorageService
  ){}




ngOnInit(): void {
  this.formLogin = new FormGroup({
    'usuario' : new FormControl('', Validators.required),
    'passe' : new FormControl('', Validators.required)
  });




  if (this.tokenStorage.getToken()) {
    this.isLoggedIn = true;
   // this.roles = this.tokenStorage.getUser();
    this.router.navigateByUrl('/dashboard');
  }


}



loginUser(): void {
  // const credentials: Credentials = {
  //   usuario: 'admin',
  //   passe: '3346',
  // };
  // this.authService.loginUser(credentials)
  //   .subscribe((res: Login) => {
  //     localStorage.setItem('platzi_token', res.access_token);
  //     this.router.navigate(['dashboard']);
  //   });
}



//login(){

  //const hashUsuario = crypto.SHA1(this.formLogin.value['usuario']);
  //const hashPasse = crypto.SHA1(this.formLogin.value['passe']);

  //this.loginService.getByUsuario(hashUsuario.toString(),hashPasse.toString()).subscribe(data => {
   // if (data.length > 0){ // si existe datos de retorno entonces si existe el usuario 
      // crear nuevo token de sesion
   //   var token = jwt.sign(this.formLogin.value['usuario'], environment.JWT_Secret);
      
   //const userId = "1";

  


    //}

 // });

 
 
//}




onSubmit(): void {
  

  this.loginService.login(this.formLogin.value['usuario'],this.formLogin.value['passe']).subscribe(
    data => {
      this.tokenStorage.saveToken(data.access_token);
      this.tokenStorage.saveUser(data);
      this.isLoginFailed = false;
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      this.lblRespuesta=true;
      //this.reloadPage();
      this.router.navigateByUrl('/dashboard');
    

     
    },
    err => {
    //  this.errorMessage = err.error.message;
      this.isLoginFailed = true;
      console.log("no existe el usuario");

      this.lblRespuesta=false;
    }
  );
}

reloadPage(): void {
  window.location.reload();
}

onLogin():void{

  // console.log("login:",this.formLogin.value);
//this.authServide.login(this.formLogin.value);

}



}
